import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "@/i18n";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Fleet } from "@/components/Fleet";
import { Stats } from "@/components/Stats";
import { Reviews } from "@/components/Reviews";
import { WhyUs } from "@/components/WhyUs";
import { FareCalculator } from "@/components/FareCalculator";
import { BookingForm } from "@/components/BookingForm";
import { ContactForm } from "@/components/ContactForm";
import { Footer } from "@/components/Footer";
import { FloatingCallBar } from "@/components/FloatingCallBar";
import Admin from "@/components/Admin";

const Landing = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Services />
      <Fleet />
      <Stats />
      <Reviews />
      <WhyUs />
      <FareCalculator />
      <BookingForm />
      <ContactForm />
    </main>
    <Footer />
    <FloatingCallBar />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.085, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App" data-testid="app-root">
        <div className="grain-overlay" />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
